import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Link,
  Switch,
} from "react-router-dom";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";

const AdmissionQueryDetails = (props) => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [loading, setLoading] = useState(false);
  const [mAdmissionQuery, setMAdmissionQuery] = useState([]);
  const [request_id, setRequest_id] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoggedIn(false);
      return;
    }

    window.scrollTo(0, 0);
    setRequest_id(props.match.params.request_id);
    getAdmissionQueryDetails();
  }, []);

  const getAdmissionQueryDetails = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const mSession = SessionManager.getCurrentSession();
    const SESSION_ID = mSession[0].session_id;
    const FUNCTION_NAME = "getAdmissionInquiryDetails.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      session_id: SESSION_ID,
      request_id: props.match.params.request_id,
    };

    const queryString = new URLSearchParams(params).toString();
    console.log("Full URL: ", `${URL}${queryString}`);

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          setMAdmissionQuery(response.data);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error>>>>>", error);
      });
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

  return (
    <Router>
      <Switch>
        <Route path="/AdminMain/AdmissionQueryDetails/:request_id" exact>
          <div className="content" style={{ background: COLORS.white }}>
            <div className="content-header">
              <div className="leftside-content-header">
                <ul className="breadcrumbs">
                  <li>
                    <i className="fa fa-home" aria-hidden="true" />
                    <a href="#">Admission query Details</a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="bg_page_grey_rounded box_shadow"
              style={{ "--mMargin": "150px" }}
            >
              <div className="row" style={{ padding: "0px 20px 0px 20px" }}>
                <h4>Admission Query Details</h4>
              </div>

              <div className="row">
                {mAdmissionQuery.map((item, index) => (
                  <div className="col-sm-12 col-md-12" key={index}>
                    <div
                      className="box_shadow bg_card_grey_outline"
                      style={{ padding: 2, margin: 10 }}
                    >
                      <h4 className="gravity_center">{`${item.student_name} (${item.father_name})`}</h4>
                      <h5 className="gravity_center">
                        {"Address: " + item.address}
                      </h5>
                      <h5 className="gravity_center">
                        {"Seeking Admission in Class: " + item.query_class}
                      </h5>
                      <h5 className="gravity_center">
                        {"Previous Class: " + item.previous_class}
                      </h5>
                      <h5 className="gravity_center">
                        {"Previous School: " + item.previous_school_name}
                      </h5>
                      <h5 className="gravity_center">
                        {"Father Name: " + item.father_name}
                      </h5>
                      <h5 className="gravity_center">
                        {"Gender: " + item.gender}
                      </h5>
                      <h5 className="gravity_center">
                        {"Community: " + item.community}
                      </h5>
                      <h5 className="gravity_center">
                        {"Religion: " + item.religion}
                      </h5>
                      <h5 className="gravity_center">
                        {"Nationality: " + item.nationality}
                      </h5>
                      <h5 className="gravity_center">
                        {"Remark: " + item.remark}
                      </h5>
                      <h5 className="gravity_center">
                        {"Date Added: " + item.date_added}
                      </h5>
                      <h5 className="gravity_center">
                        {"Status: " + item.status}
                      </h5>
                      <h5 className="gravity_center">
                        {"Contact Number: " + item.contact_number}
                      </h5>

                      <Link>
                        <div className="row">
                          <div className="col-sm-12 col-md-12 gravity_center">
                            <button
                              className="btn btn-success"
                              style={{
                                fontSize: "16px",
                                margin: "3px 2px 3px 2px",
                                width: "100%",
                                background: COLORS.primary_color_shade5,
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Route>
      </Switch>
    </Router>
  );
};

export default AdmissionQueryDetails;
